import Select from "react-select";
import { NOTIFICATION_TITLE_MAX_LENGTH } from "../notificationLimits";

function ScheduledNotificationEditRow({
    editBody,
    editRecipients,
    editScheduledDateTime,
    editTitle,
    onCancel,
    onSave,
    onSetBody,
    onSetRecipients,
    onSetScheduledDateTime,
    onSetTitle,
    saveStatus,
    user_names,
}) {
    const optionStyles = {
        multiValue: (styles, { data }) => ({ ...styles, color: data.color }),
        multiValueLabel: (styles, { data }) => ({ ...styles, color: data.color }),
        option: (styles, { data }) => ({ ...styles, color: data.color }),
    };

    return (
        <tr className="scheduled-edit-row">
            <td colSpan="7">
                <div className="scheduled-edit-panel">
                    <div className="scheduled-edit-grid">
                        <label className="scheduled-edit-field">
                            <span>Títol</span>
                            <input
                                value={editTitle}
                                maxLength={NOTIFICATION_TITLE_MAX_LENGTH}
                                onChange={event => onSetTitle(event.target.value)}
                            />
                        </label>
                        <label className="scheduled-edit-field">
                            <span>Data programada</span>
                            <input
                                type="datetime-local"
                                value={editScheduledDateTime}
                                onChange={event => onSetScheduledDateTime(event.target.value)}
                            />
                        </label>
                    </div>
                    <label className="scheduled-edit-field">
                        <span>Missatge</span>
                        <textarea
                            value={editBody}
                            maxLength={256}
                            onChange={event => onSetBody(event.target.value)}
                        />
                    </label>
                    <label className="scheduled-edit-field">
                        <span>Destinataris</span>
                        <Select
                            options={user_names}
                            isMulti
                            value={editRecipients}
                            onChange={onSetRecipients}
                            styles={optionStyles}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Cerca i selecciona castellers..."
                        />
                    </label>
                    <div className="scheduled-edit-footer">
                        {saveStatus?.message ? (
                            <span className={`scheduled-edit-status ${saveStatus.type || ''}`}>
                                {saveStatus.message}
                            </span>
                        ) : <span />}
                        <div className="scheduled-edit-buttons">
                            <button onClick={onCancel}>
                                Tancar
                            </button>
                            <button
                                className="primary"
                                onClick={onSave}
                                disabled={saveStatus?.type === 'pending'}
                            >
                                {saveStatus?.type === 'pending' ? 'Guardant...' : 'Desar canvis'}
                            </button>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}

export default ScheduledNotificationEditRow;
